import axios from "axios";
import { useContext, useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
// import CommonAlert from "../../Commonalert/commonalert";
import { Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { timezonechange } from "../../Commonfun";
import { Commonfun } from '../../Commonfun';
import { timezoneval } from '../../Commonfun';
// import { timezoneval } from "./Commonfun";
import { ToastContainer, toast } from 'react-toastify';
import { Helmet } from "react-helmet";
import Loader from "../../CommonLoader";
import { CommonErrorAlert } from "../../../../Commonalert/commonErrorAlert";
import { AppContext } from "../../../../Context/Context";
import CommonBreadCrumb from "../../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CommonAlert from "../../../../Commonalert/commonalert";
import Rightsidebar from "../../Rightsidebar/Rightsidebar";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import UserActivityTracker from "../../../../hooks/userActivityTracker";



export default function SslConfig() {

    const param = useParams();
    const navigate = useNavigate();
    const ticketId = param.id;
    const esodata = useSelector((state) => state);
    const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
    const apiToken = esodata?.apiauthkey?.value;
    const [sslConfig, setsslConfig] = useState(null);
    const [apiopen, setapiOpen] = useState(false);
    const [apierrorMsg, setapierrorMsg] = useState();
    const [loading, setLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
    const [jobId, setJobId] = useState("");
    const dropdownRef = useRef();
    const [download, setDownload] = useState(false);
    const menuItemStyle = {
        padding: "10px 16px",
        cursor: "pointer",
        borderBottom: "1px solid #eee",
        backgroundColor: "#fff",
        transition: "background 0.2s",
    };

    //faq
    const [faqData, setfaqData] = useState("2")
    const [toggle, setToggle] = useState(false);
    const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
    //run report
    const [isReportOpen, setIsReportOpen] = useState(false);
    const [successApiopen, setSuccessApiOpen] = useState(false);
    const [successApierrorMsg, setSucessApierrorMsg] = useState('');


    useEffect(() => {
        callUserdataApi();
        faqdatafun();
    }, []);

    const callUserdataApi = () => {
        setLoading(true);
        console.log('apiToken', apiToken);
        axios.get(`${process.env.REACT_APP_API_URL}security_tools/ssl_audit/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobId}&formats=''&timezone=${timezoneval()}`, {
            headers: {
                Authorization: `${apiToken}`,
            }
        }).then(sslConfig => {
            console.log('sslConfig', sslConfig)
            setsslConfig(sslConfig.data)
        }).catch(error => {
            if (
                error?.response?.status == 599 ||
                error?.response?.status == 400 ||
                error?.response?.status == 500
            ) {
                setapiOpen(true);
                if (error?.response?.data?.security_config) {
                    const securityError = <div dangerouslySetInnerHTML={{ __html: error?.response?.data?.security_config }} />
                    setapierrorMsg(securityError);
                } else {
                    setapierrorMsg(error?.response?.data?.error)
                }
            } else if (
                error?.code == "ERR_NETWORK" ||
                error?.response?.status == 404
            ) {
                navigate("/errorpages");
            }
        })
        setLoading(false);
    }

    const apihandleClose = () => {
        setapiOpen(false);
    }

    const pdfdown = async () => {

        setLoading(true);
        setIsDownloading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}security_tools/ssl_audit/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobId}&formats=pdf&timezone=${timezoneval()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/pdf',
                    Authorization: `${apiToken}`,
                },
            });

            if (response.ok) {

                const blob = await response.blob();


                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                var filedata = await Commonfun("SslConfig", "pdf", apiToken, esodata.domaindata.value.header_selected);
                link.download = filedata;
                link.click();


                window.URL.revokeObjectURL(link.href);
            } else {
                if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
                    response.json().then(data => {
                        setapiOpen(true);
                        setapierrorMsg(data?.error)
                    })
                }
                else if (response?.code == "ERR_NETWORK") {
                    navigate('/errorpages')
                }
            }
        } catch (error) {
            toast.error("No Data", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            console.error('Error during PDF download:', error);
        }
        setLoading(false);
        setIsDownloading(false);


    }

    const csvdown = async () => {
        setLoading(true);
        setIsDownloadingcsv(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}security_tools/ssl_audit/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${jobId}&formats=csv&timezone=${timezoneval()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/pdf',
                    Authorization: `${apiToken}`,
                },
            });
            if (response.ok) {
                const blob = await response.blob();
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'SslConfig.csv';

                link.click();


                window.URL.revokeObjectURL(link.href);
            } else {
                if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
                    response.json().then(data => {
                        setapiOpen(true);
                        setapierrorMsg(data?.error)
                    })
                }
                else if (response?.code == "ERR_NETWORK") {
                    navigate('/errorpages')
                }
            }
        } catch (error) {
            toast.error("No Data", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
            console.error('Error during PDF download:', error);
        }
        setLoading(false);
        setIsDownloadingcsv(false);

    }


    const handleToggle = () => {
        if (faqData != 1) {
            setfaqData(1)
        }
        else {
            setfaqData(2)
        }
        setToggle((pre) => !pre);
    };

    const faqdatafun = async (menubutval = "") => {
        var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=74`

        try {
            const doaminsectiondatavalue = await axios.get(
                datavar,
                {
                    headers: {
                        Authorization: `${apiToken}`,
                    },
                }
            ).catch((error) => {
                if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                    setapiOpen(true);
                    setapierrorMsg(error?.response?.data?.error)
                }
                else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                    navigate('/errorpages')
                }
            });
            if (doaminsectiondatavalue?.data) {
                SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
            }
        } catch (err) { }
    }

    //Run report

    const closeRunReport = () => {
        setIsReportOpen(false);
    }

    const runReportNow = async () => {
        setLoading(true);

        const datavalue = await axios.get(
            `${process.env.REACT_APP_API_URL}security_tools/run_security_report/?user_domain_id=${esodata.domaindata.value.header_selected}&report_type=ssl_audit`, {
            headers: {
                Authorization: `${apiToken}`,
            },
        }
        ).catch((error) => {
            if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
                setapiOpen(true);
                setapierrorMsg(error?.response?.data?.error)
            }
            else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
                navigate('/errorpages')
            }
        });
        if (datavalue?.status === 200) {
            setSuccessApiOpen(true);
            setSucessApierrorMsg(datavalue?.data?.success);
        }

        setIsReportOpen(false);
        setLoading(false);
    };

    const successApiClose = () => {
        setSuccessApiOpen(false);
    }


    return (
        <><ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />
            <Helmet>
                <meta charSet="utf-8" />
                <title>SSL Configuration</title>
            </Helmet>
            {loading === true ? <Loader /> : null}
            <div className={`over_all_container over_all_accessibility ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
                <Container maxWidth={false} className="dashboard-container">
                    <Box className="dashboard-box">
                        <Grid container className="dashboard-grid">
                            <Grid item xs={12} md={4}>
                                <div>
                                    <h1 className="dashboard_header">
                                        SSL Configuration
                                        <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                                    </h1>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <div className="top_breadcrumb_menu">
                                    <div className="exportpdf_outer">
                                        <div className="breadcrumb-wrapper">
                                            <CommonBreadCrumb breadcrumbValue={[
                                                { title: 'Security Tools', active: true },
                                                { title: 'SSL Configuration', active: true }
                                            ]} />
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <Container maxWidth={false} className="dashboard-container">
                    <Box className="dashboard-box-time">
                        <Grid container className="dashboard-grid">
                            <Grid item xs={12} md={6}>
                                <div className="time_zone">
                                    <span className="timezone-date">{timezonechange(sslConfig?.job_date)} </span><br />
                                    <span className="timezone-val">{timezoneval()}</span>
                                </div>
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <div style={{ display: "flex", gap: "16px", alignItems: "center", justifyContent: "end", marginRight: "13px" }}>
                                    <button
                                        title="Security Audit Settings"
                                        className="btn_dashboard"
                                        onClick={() => navigate('/security-audit-settings')}
                                    >
                                        Security Audit Settings
                                    </button>
                                    <button
                                        title="Run Report"
                                        className="btn_dashboard"
                                        onClick={() => setIsReportOpen(true)}
                                    // onClick={() => {
                                    //   if (first.statusDomain) {
                                    //     setcheckD(first.statusDomain);
                                    //   } else {

                                    //     setfaqData(2);
                                    //     setToggle(false);
                                    //     SetRunReportPopShow(true);
                                    //   }
                                    // }}
                                    // disabled={!analysisSummaryPlan.status}
                                    >
                                        Run Report Now
                                    </button>

                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <Container maxWidth={false} className="dashboard-card-container">
                    <Box className="dashboard-box-card">
                        <Grid container className="dashboard-card-grid">
                            <Grid item xs={12} md={12}>
                                <div className="">
                                    <div className="color-checker-container">
                                        <div style={{ placeSelf: 'end' }}>
                                            <div
                                                ref={dropdownRef}
                                                style={{
                                                    position: "relative",
                                                    display: "inline-block",
                                                    border: "1px solid #ff6600",
                                                    borderRadius: "99rem",
                                                }}
                                            >
                                                <button
                                                    className="dashboard_download"
                                                    onClick={() => setDownload((prev) => !prev)}
                                                >
                                                    Download{" "}
                                                    <svg
                                                        className="filter"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="24"
                                                        height="24"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                                        <polyline points="7 10 12 15 17 10" />
                                                        <line x1="12" y1="15" x2="12" y2="3" />
                                                    </svg>
                                                </button>
                                                {download && (
                                                    <div
                                                        className="download_dropdown"
                                                        style={{
                                                            position: "absolute",
                                                            top: "110%",
                                                            left: 0,
                                                            backgroundColor: "white",
                                                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                                            borderRadius: "4px",
                                                            minWidth: "150px",
                                                            zIndex: 1000,
                                                        }}
                                                    >

                                                        <div
                                                            onClick={() => {
                                                                pdfdown();
                                                                setDownload(false);
                                                            }}
                                                            onMouseOver={(e) =>
                                                                (e.currentTarget.style.backgroundColor = "#f5f5f5")
                                                            }
                                                            onMouseOut={(e) =>
                                                                (e.currentTarget.style.backgroundColor = "#fff")
                                                            }
                                                            style={menuItemStyle}
                                                        >
                                                            Download PDF
                                                        </div>


                                                        <div
                                                            onClick={() => {
                                                                csvdown();
                                                                setDownload(false);
                                                            }}
                                                            onMouseOver={(e) =>
                                                                (e.currentTarget.style.backgroundColor = "#f5f5f5")
                                                            }
                                                            onMouseOut={(e) =>
                                                                (e.currentTarget.style.backgroundColor = "#fff")
                                                            }
                                                            style={{ ...menuItemStyle, borderBottom: "none" }}
                                                        >
                                                            Download CSV
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <table className="table">
                                            <col style={{ width: "50%" }} />
                                            <col style={{ width: "50%" }} />
                                            <tbody>
                                                <tr>
                                                    <td className="table-label" style={{ fontWeight: 800 }}>Domain URL: </td>
                                                    <td>{sslConfig?.domain_url || '-'}</td>
                                                </tr>
                                                <tr>
                                                    <td className="table-label" style={{ fontWeight: 800 }}>Status: </td>
                                                    <td>{sslConfig?.table_data?.status} {sslConfig?.table_data?.status === 'Valid' ? <CheckCircleIcon style={{ color: 'green' }} /> : <CancelIcon style={{ color: 'red' }} />}</td>
                                                </tr>
                                                <tr>
                                                    <td className="table-label" style={{ fontWeight: 800 }}>Expiry Date: </td>
                                                    <td>
                                                        {sslConfig?.table_data?.expiry_date ? timezonechange(sslConfig?.table_data?.expiry_date) : '-'}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="table-label" style={{ fontWeight: 800 }}>No. of days for Expiry: </td>
                                                    <td>
                                                        {sslConfig?.table_data?.days_left || '-'}

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="table-label" style={{ fontWeight: 800 }}>Last Checked: </td>
                                                    <td>{sslConfig?.job_date ? timezonechange(sslConfig?.job_date) : '-'}</td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <Container maxWidth={false} className="footer-container">
                    <Box className="footer-box">
                        <Grid container className="footer-grid">
                            <Grid item xs={12} md={6}>
                                <div className="footer-left">
                                    <p className="footer-text">
                                        All Rights Reserved Copyright © 2026 |
                                        <a href="https://www.egrovesys.com/" target="blank">
                                            <span className="footer-brand"> Elite site Optimizer</span>
                                        </a>
                                    </p>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <div className="footer-right">
                                    <p>{/* Add content if needed */}</p>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <div className="cnt_audit_outer_wrap">
                    <div >
                        {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}
                    </div>
                </div>

                <Dialog
                    open={isReportOpen}
                    onClose={closeRunReport}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className="competitor_test_filter job_date_filter over_all_accessibility"
                >
                    <DialogTitle className="keyword-dialog-header ">
                        {"Run Report"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            <div>
                                Can we run the report for SSL Audit ?
                            </div>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className="dialog-action-button">
                        <button
                            className="form_submit_btn"
                            onClick={runReportNow}
                            style={{ cursor: "pointer" }}
                        >
                            Run
                        </button>
                        <button style={{ cursor: "pointer" }} onClick={closeRunReport}>
                            Cancel
                        </button>
                    </DialogActions>
                </Dialog>

                <CommonErrorAlert
                    data={{
                        apiopen: successApiopen,
                        apiErrorMsg: successApierrorMsg,
                        isIconStyled: false
                    }}
                    closeAlert={successApiClose} />

                <CommonErrorAlert
                    data={{
                        apiopen: apiopen,
                        apiErrorMsg: apierrorMsg,
                        isIconStyled: true
                    }}
                    closeAlert={apihandleClose}
                />
                <UserActivityTracker pagename="Security Tools - SSL Configuration" />
            </div>
        </>
    )
}